import { http } from 'http';

export default {
  deleteCampaign: campaignId => http.delete(`/campaigns/${campaignId}`)
};
